<template>
  <div class="page" id="game">
    <!-- <img class="banner" src="~@/assets/logo.png" /> -->
    <div class="qna">
      <div
        class="questions"
        v-for="(item, index) in quesList"
        :key="index"
        v-show="index == curQues"
      >
        <div class="topinfo flex">
          <div class="questions_tag flex" v-i18n>{{ item.question_type }}</div>
          <div class="questions_num" :data-options="item.options + '1'">
            <span style="font-size:26px;">{{ index + 1 }}</span>
            /{{ quesList.length }}
          </div>
        </div>
        <div class="question">
          {{ item.question_content }}
          <!-- <div class="ques_image ques_type2" v-if="item.question_type2 == '图文题'">
            <img :src="item.imgurl" style="width:100%" @click="imgShow(item.imgurl)" />
          </div>
          <div class="ques_audio ques_type2" v-if="item.question_type2 == '音频题'">
            <audio controls :src="item.imgurl" style="width: 100%;"></audio>
          </div>-->
          <div class="ques_video ques_type2">
            <video
              id="VideoPlay"
              webkit-playsinline
              playsinline
              x5-playsinline
              controls
              preload="auto"
              controlslist="nodownload"
              :poster="item.videoimg"
              :src="item.imgurl"
              type="video/mp4"
              style="width: 100%;height:100%;"
            ></video>
          </div>
          <!-- :poster="'https://activity.sznews.com/'+item.videoimg" -->
        </div>

        <!-- {{item}} -->
        <div
          class="option_bar flex"
          v-for="(option, oindex) in item.options"
          :key="oindex"
          @click="onChoose(oindex)"
          v-show="option.value ? option.value.trim() : ''"
        >
          <div class="dot" :class="option.chosen ? 'dot_hover' : ''">{{ option.key }}</div>
          {{ option.value }}
        </div>

        <van-button
          type="primary"
          size="large"
          round
          block
          class="next_btn"
          color="linear-gradient(to right, #ffa726, #f5793f, #f25e28)"
          @click="toNextQues"
        >{{ btnText }}</van-button>
      </div>
    </div>

    <van-popup v-model="resultShow" :overlay="scoreShow?false:true" :close-on-click-overlay='false'>
      <div class="answer_pop success" v-if="answerCorrect && !scoreShow">
        <img src="@/assets/success.jpg" alt />
      </div>
      <div class="answer_pop wrong" v-if="!answerCorrect && !scoreShow">
        <img src="@/assets/wrong_top.jpg" alt />
        <p v-if="answer_tip.trim().length">
          <b>Tips:</b>
          {{answer_tip}}
        </p>
        <van-button
          type="primary"
          size="small"
          round
          block
          class="continue_btn"
          color="#252122"
          @click="toNextQues_wrong"
        >continue</van-button>
      </div>
      <div class="answer_pop scoreShow" v-if="scoreShow">
        <img src="@/assets/scoreShow.jpg" alt />
        <p>
          <span v-i18n>答题成功！</span>
          <b v-i18n="'得分:'">{{score}}</b>
          
        </p>
        <van-button
          type="primary"
          size="small"
          round
          block
          class="finish_btn"
          color="#252122"
          @click="$router.replace('/')"
        >OK 好的</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import index from "./index.js";

export default {
  ...index
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
